<template>
  <div id="rules">
    <h2 class="shrink text-center logo-small mb-2">
      <span class="primary--text">Rules</span>
    </h2>
    <v-sheet class="bg2 pa-4">
      <p><span class="font-weight-black accent--text">Object:</span></p>
      <p>Accumulate the most points. Teams earn points for each game they win multiplied by their bracket seed.</p>

      <p><span class="font-weight-black accent--text">Scoring System:</span></p>

      <v-simple-table dense class="mb-4">
        <thead>
          <tr class="bg3">
            <th class="accent--text">Advancing to</th>
            <th class="accent--text">Points</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>2nd Round</td>
            <td>1</td>
          </tr>
          <tr>
            <td>Sweet 16</td>
            <td>2</td>
          </tr>
          <tr>
            <td>Elite 8</td>
            <td>4</td>
          </tr>
          <tr>
            <td>Final 4</td>
            <td>8</td>
          </tr>
          <tr>
            <td>Championship Game</td>
            <td>16</td>
          </tr>
          <tr>
            <td>Winning it all</td>
            <td>32</td>
          </tr>
        </tbody>
      </v-simple-table>

      <p><span class="font-weight-black accent--text">Scoring Multiplier:</span></p>
      <p>For each award of points it is multiplied by that team's bracket seed.</p>

      <p>Thus, if a "1" seeded team wins the tourney they would receive 1+2+4+8+16+32 for a total of 63 points.</p>

      <p>If a "12" seed advances to the sweet 16 they would receive 1*"12"+2*"12" for a total of 36 points.</p>

      <p>While a "5" seed advancing to the Elite 8 earns 1*"5"+2*"5"+4*"5" for 35 points.</p>

      <p><span class="font-weight-black accent--text">Salary Cap and Team Costs:</span></p>
      <p>The cost for each team is determined by the following formula: (17 minus the bracket seed). Thus a "1" seed costs 16 (17-1). A "10" Seed would cost 7 (17-10) and a "16" seed costs 1 (17-16).</p>

      <p>The Total salary cap for your roster of teams is 90. You may have 1 to 14 teams as long as the total salary doesn't exceed 90.</p>

      <p>Any unused portion of the salary cap, counts as points for your aggregate score. Thus if you use only 76 for your salary, your starting points will be 14.</p>
   </v-sheet>
  </div>
</template>

<script>
export default {
  name: 'Rules',
  data() {
    return {
      
    }
  }
}
</script>

<style>

</style>